import { Brand, DevTools, Position, State } from 'src/types'
import { DevTool } from 'src/features/development'
// 捕球面の描画
import { Box } from '@mui/material'
import { dxmCanvasGloveFront } from 'src/features/dxm/drawer/rightThrow/glove/front/useDxmCanvasGloveFront'
import { positionChecker } from 'src/logic'
import { ysrCanvasGloveFront } from 'src/features/yellStory/drawer/glove/front/useYsrCanvasGloveFront'
import { gorillaCanvasGloveFront } from 'src/features/gorilla/drawer/glove/rightThrow/front/useGorillaCanvasGloveFront'
import { atomsCanvasGloveFront } from 'src/features/atoms/glove/drawer/rightThrow/glove/front/useAtomsCanvasGloveFront'
import { atomsCanvasCatcherMittFront } from 'src/features/atoms/glove/drawer/rightThrow/catchermitt/front/useCanvasCatcherMittFront'
import { atomsCanvasFirstMittFront } from 'src/features/atoms/glove/drawer/rightThrow/firstmitt/front/useAtomsCanvasFirstMittFront'
import { gorillaCanvasFirstMittFront } from 'src/features/gorilla/drawer/firstmitt/rightThrow/front/useGorillaCanvasFirstMittFront'
import { gorillaCanvasCatcherMittFront } from 'src/features/gorilla/drawer/catchermitt/rightThrow/front/useGorillaCanvasCatcherMittFront'
import { atomsCanvasGloveFrontLeftThrow } from 'src/features/atoms/glove/drawer/leftThrow/glove/front/useAtomsCanvasGloveFront'
import { atomsCanvasFirstMittFrontLeftThrow } from 'src/features/atoms/glove/drawer/leftThrow/firstmitt/front/useAtomsCanvasFirstMittFront'
import { atomsCanvasCatcherMittFrontLeftThrow } from 'src/features/atoms/glove/drawer/leftThrow/catchermitt/front/useCanvasCatcherMittFront'
import { dxmCanvasGloveFrontLeftThrow } from 'src/features/dxm/drawer/leftThrow/glove/front/useDxmCanvasGloveFront'
import { gorillaCanvasGloveFrontLeftThrow } from 'src/features/gorilla/drawer/glove/leftThrow/front/useGorillaCanvasGloveFrontLeftThrow'
import { gorillaCanvasFirstMittFrontLeftThrow } from 'src/features/gorilla/drawer/firstmitt/leftThrow/front/useGorillaCanvasFirstMittFront'
import { dxmCanvasCatcherMittFront } from 'src/features/dxm/drawer/rightThrow/catcher/front/useCanvasCatcherMittFront'
import { dxmCanvasCatcherMittFrontLeftThrow } from 'src/features/dxm/drawer/leftThrow/catcher/front/dxmCanvasCatcherMittFront'
import { dxmCanvasFirstMittFront } from 'src/features/dxm/drawer/rightThrow/firstmitt/front/useAtomsCanvasFirstMittFront'
import { dxmCanvasFirstMittFrontLeftThrow } from 'src/features/dxm/drawer/leftThrow/firstmitt/front/useDxmCanvasFirstMittFront'
import { usModelOfAtomsChecker } from 'src/logic'
import { useEffect, useState } from 'react'
import { CircularProgress } from '@mui/material'

type Props = {
  state: State
  position: Position
  brand: Brand
  devFlg?: boolean
  domId?: string
  devTools?: DevTools
  devToolStyle?: {
    backgroundImage: string
    backgroundRepeat: string
    backgroundPosition: string
    backgroundSize: string
    maxWidth: string
  }
  maxWidth?: string
  handleCoordinate?: (e: React.MouseEvent<HTMLCanvasElement, MouseEvent>) => void
}

export const FigureFront: React.FC<Props> = ({
  state,
  brand,
  position,
  devFlg,
  domId,
  devTools,
  devToolStyle,
  maxWidth = '100%',
  handleCoordinate
}) => {
  const dominantArmValue = state.dominantArm.value
  const productNumber = state.baseModel?.productNumber
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    let isMounted = true
    const draw = async () => {
      setLoading(true)
      const canvas = document.getElementById(domId || 'canvasFront') as HTMLCanvasElement
      const ctx = canvas.getContext('2d') as CanvasRenderingContext2D
      ctx.strokeStyle = '#282828'
      ctx.lineWidth = 2
      const canvasWidth = canvas.width
      if (usModelOfAtomsChecker(productNumber)) {
        await atomsCanvasGloveFront(ctx, state, position)
        await new Promise((res) => setTimeout(res, 500))
        if (isMounted) setLoading(false)
        return
      }
      switch (position) {
        case 'catcher':
          switch (brand) {
            case 'atoms':
              switch (state.dominantArm.value) {
                case 'leftThrow':
                  await atomsCanvasCatcherMittFrontLeftThrow(ctx, state, canvasWidth)
                  break
                default:
                  await atomsCanvasCatcherMittFront(ctx, state)
                  break
              }
              break
            case 'dxm':
              switch (state.dominantArm.value) {
                case 'leftThrow':
                  await dxmCanvasCatcherMittFrontLeftThrow(ctx, state, canvasWidth)
                  break
                default:
                  await dxmCanvasCatcherMittFront(ctx, state)
                  break
              }
              break
            case 'gorilla':
              await gorillaCanvasCatcherMittFront(ctx, state)
              break
          }
          break
        case 'first':
          switch (brand) {
            case 'atoms':
              switch (state.dominantArm.value) {
                case 'leftThrow':
                  await atomsCanvasFirstMittFrontLeftThrow(ctx, state, canvasWidth)
                  break
                default:
                  await atomsCanvasFirstMittFront(ctx, state)
                  break
              }
              break
            case 'gorilla':
              switch (state.dominantArm.value) {
                case 'leftThrow':
                  await gorillaCanvasFirstMittFrontLeftThrow(ctx, state, canvasWidth)
                  break
                default:
                  await gorillaCanvasFirstMittFront(ctx, state)
                  break
              }
              break
            case 'dxm':
              switch (state.dominantArm.value) {
                case 'leftThrow':
                  await dxmCanvasFirstMittFrontLeftThrow(ctx, state, canvasWidth)
                  break
                default:
                  await dxmCanvasFirstMittFront(ctx, state)
                  break
              }
              break
          }
          break
        default:
          switch (brand) {
            case 'atoms':
              switch (dominantArmValue) {
                case 'leftThrow':
                  await atomsCanvasGloveFrontLeftThrow(ctx, state, position, canvasWidth)
                  break
                default:
                  await atomsCanvasGloveFront(ctx, state, position)
                  break
              }
              break
            case 'yellStory':
              await ysrCanvasGloveFront(ctx, state)
              break
            case 'dxm':
              switch (dominantArmValue) {
                case 'leftThrow':
                  await dxmCanvasGloveFrontLeftThrow(ctx, state, position, canvasWidth)
                  break
                default:
                  await dxmCanvasGloveFront(ctx, state, position)
                  break
              }
              break
            case 'gorilla':
              switch (dominantArmValue) {
                case 'leftThrow':
                  await gorillaCanvasGloveFrontLeftThrow(ctx, state, position, canvasWidth)
                  break
                default:
                  await gorillaCanvasGloveFront(ctx, state, position)
                  break
              }
              break
          }
          break
      }
      await new Promise((res) => setTimeout(res, 500))
      if (isMounted) setLoading(false)
    }
    draw()
    return () => {
      isMounted = false
    }
  }, [state])
  const { isMitt } = positionChecker(position)
  return (
    <Box position="relative" width={maxWidth}>
      {devFlg && handleCoordinate ? (
        <Box>
          <canvas
            width={880}
            height={isMitt ? 680 : 630}
            id={domId || 'canvasFront'}
            style={{ maxWidth, ...devToolStyle }}
            onClick={(e) => handleCoordinate(e)}
          />
          <DevTool devTools={devTools} />
        </Box>
      ) : (
        <canvas width={880} height={isMitt ? 680 : 630} id={domId || 'canvasFront'} style={{ maxWidth }} />
      )}
      {loading && (
        <Box
          position="absolute"
          top={0}
          left={0}
          width="100%"
          height="100%"
          display="flex"
          alignItems="center"
          justifyContent="center"
          zIndex={10}
          bgcolor="rgba(255,255,255,0.5)"
        >
          <CircularProgress />
        </Box>
      )}
    </Box>
  )
}
